import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType } from 'api/utils/RepositoryTypes';

type Props = {
    slug: string;
};

export interface SimpleProductType {
    attributes: Array<{
        code: string;
        name: string;
        value: string;
    }>;
    availability: {
        availableForSale: boolean;
        reason: string;
    };
    code: string;
    description: string;
    details: {
        author: string;
        appUrl: { name: string; url: string };
        flipbook: { image: string; url: string };
        men: string;
    };
    images: Array<{
        type: string;
        items: Array<{
            path: string;
            sizes: Array<{
                absolutePath: string;
                size: string;
            }>;
        }>;
    }>;
    labels: Array<{
        code: string;
        name: string;
    }>;
    minQuantity: number;
    name: string;
    originalPrice: {
        current: number;
        currency: string;
    };
    price: {
        current: number;
        currency: string;
    };
    shortDescription: string;
    slug: string;
    type: string;
    taxAmount: number;
}

class SimpleProductRepository extends BaseRepositoryClass implements RepositoryType {
    get({ slug }: Props) {
        return this.requester.get<SimpleProductType>(`grant/product/by-slug/${slug}`);
    }
}

export default SimpleProductRepository;
